import { memo, useEffect } from 'react';

import { useBusinessToolStore } from 'store/useBusinessToolStore';
import { getBusinessPlanChapters } from 'store/useBusinessToolStore/selectors';

import { getCoverPageProps } from './mapping';

type CoverPageProps = {
  saveSectionProps: (key: string, props: Record<string, any>) => void;
};

export const CoverPage = memo(({ saveSectionProps }: CoverPageProps) => {
  const businessPlanChapters = useBusinessToolStore(getBusinessPlanChapters);
  const props = getCoverPageProps(businessPlanChapters);

  useEffect(() => {
    saveSectionProps('coverPage', { ...props });
  }, [props]);

  return null;
});
